import React, { useEffect, useState } from "react";

import Axios from "../../services/Api";
import app_params from "../../config/params";
import AcquisitionItem from "../../components/AcquisitionItem/AcquisitionItem";
import { Container } from "react-bootstrap";

// import styles from "./AcquisitionScreen.module.css";

const AcquisitionScreen = (props) => {
  const [acquisitions, setAcquisitions] = useState({ isSet: false });

  useEffect(() => {
    Axios.GetAcquisitions()
      .then((res) => res.data)
      .then((data) => {
        if (data?.success === "true") {
          console.log(data);
          setAcquisitions({
            isSet: true,
            records: data.records,
          });
        } else {
          setAcquisitions({ isSet: false });
          window.location.replace(`${app_params.basepath}/404`);
        }
      })
      .catch((e) => {
        console.log(e);
        setAcquisitions({ isSet: false });
      });
  }, []);

  return (
    <React.Fragment>
      <section className="c-top-simple-section"></section>
      <div className="mx-0 px-3 px-md-4 px-xl-5">
        <div className="c-top-header-section">
          <Container>
            <div className="c-top-header-section-collection jaja">
              <div className="c-top-header-container d-flex justify-content-center">
                <div>
                  <div className="c-top-header-title">
                    <h1>Nuevas Adquisiciones CIRMA</h1>
                  </div>
                  <div className="c-divisor">
                    <div className="c-line" style={{ width: "100%" }}></div>
                  </div>
                  <div className="c-top-header-title">
                    <h6>TITULOS DE RECIENTE INGRESO</h6>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
      {/* <div className="c-top-header-section">
        <div className="container">
          <div className="c-top-header-container">
            <div className="c-top-header-title">
              <h1>Nuevas Adquisiciones CIRMA</h1>
            </div>
            <div className="c-top-header-subtitle">
              TITULOS DE RECIENTE INGRESO
            </div>
          </div>
        </div>
      </div> */}
      <div className="container">
        <section className="c-simple-section c-research-cirma">
          {acquisitions.isSet && (
            <div className="row">
              {Array.isArray(acquisitions?.records) && (
                <React.Fragment>
                  {acquisitions?.records.map((item) => (
                    <AcquisitionItem item={item} key={item.key} />
                  ))}
                </React.Fragment>
              )}
              {!Array.isArray(acquisitions?.records) && (
                <React.Fragment>
                  <AcquisitionItem
                    item={acquisitions.records}
                    key={acquisitions.records.key}
                  />
                </React.Fragment>
              )}
            </div>
          )}
        </section>
      </div>
    </React.Fragment>
  );
};

export default AcquisitionScreen;
